import { render, staticRenderFns } from "./doneCheck.vue?vue&type=template&id=06f4b850&scoped=true&"
import script from "./doneCheck.vue?vue&type=script&lang=js&"
export * from "./doneCheck.vue?vue&type=script&lang=js&"
import style0 from "./doneCheck.vue?vue&type=style&index=0&id=06f4b850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4b850",
  null
  
)

export default component.exports